import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { MarketplaceManagerService } from 'src/app/services/marketplace-manager.service';
import { SharedFeaturesService } from 'src/app/services/shared-features.service';
import { ShowDialogsComponent } from 'src/app/components/show-dialogs/show-dialogs.component';

/**
 * Shared logic for configure (add/update) and delete-with-confirm flows
 * to reduce duplication between manage-webchat and manage-customer-homepage.
 */
export abstract class BaseManageConfiguration {
  constructor(
    protected dialog: MatDialog,
    protected marketplaceManagerServices: MarketplaceManagerService,
    protected sharedServices: SharedFeaturesService
  ) {}

  protected handleConfigureDialog<T>(
    dialogRef: { afterClosed: () => Observable<T | undefined> },
    apiCall: (result: T) => Observable<{ message?: string }>,
    refresh: () => void
  ): void {
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        apiCall(result).subscribe({
          next: (response) => {
            this.sharedServices.openSnackBar(
              response?.message ?? '',
              'Close',
              'success-snackbar'
            );
            refresh();
          },
          error: (error) => {
            console.error('An error occurred', error);
            this.sharedServices.openSnackBar(
              error?.error?.error || error?.message || 'An error occurred',
              'Close',
              'error-snackbar'
            );
          },
        });
      }
    });
  }

  protected handleDeleteConfirm(
    name: string,
    message: string,
    deleteCall: (name: string) => Observable<{ message?: string }>,
    refresh: () => void
  ): void {
    const dialogRef = this.dialog.open(ShowDialogsComponent, {
      data: {
        title: 'Delete configuration',
        message,
        confirmText: 'Delete',
        cancelText: 'Cancel',
        danger: true,
      },
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        deleteCall(name).subscribe({
          next: (response) => {
            refresh();
            this.sharedServices.openSnackBar(
              response?.message ?? '',
              'Close',
              'success-snackbar'
            );
          },
          error: (error) => {
            console.error('An error occurred', error);
            this.sharedServices.openSnackBar(
              error?.error || error?.error?.message || 'An error occurred',
              'Close',
              'error-snackbar'
            );
          },
        });
      }
    });
  }
}
